import { IBangDiemSinhVienSelectRequest } from "../../../model/request/in-bang-diem/IBangDiemSinhVienSelectRequest";
import { IBangDiemSinhVienResponse } from "../../../model/response/in-bang-diem/IBangDiemSinhVienResponse";
import { IInBangDiemActionTypes } from "../../action-types/in-bang-diem/IInBangDiemActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IInBangDiemReducer } from "../../reducer-model/in-bang-diem/IInBangDiemReducer";

const iniState : IInBangDiemReducer = {
    bangDiemSinhViens: [],
    sinhVienSelected: [],
}

export const InBangDiemReducer = (state: IInBangDiemReducer = iniState, action: IInBangDiemActionTypes): IInBangDiemReducer => {
    switch (action.type) {
        case "IN_BANG_DIEM_INI_START":
            const obj = action.payload as  IBangDiemSinhVienSelectRequest;
            return {
                ...state,
                 bangDiemSinhViens: [...state.bangDiemSinhViens, {
                    id_sv: obj.id_sv,
                    id_dt: obj.id_dt,
                    hoc_ky: obj.hoc_ky,
                    nam_hoc: obj.nam_hoc,
                    status: eReducerStatusBase.is_not_initialization,
                }]
            };
        case "IN_BANG_DIEM_LOAD_BANG_DIEM_START":
           
            return {
                ...state,
                bangDiemSinhViens: state.bangDiemSinhViens.map(bangDiem => {
                    if (bangDiem.id_sv === action.payload.id_sv && bangDiem.id_dt === action.payload.id_dt && bangDiem.hoc_ky === action.payload.hoc_ky && bangDiem.nam_hoc === action.payload.nam_hoc) {
                        return {
                            ...bangDiem,
                            status: eReducerStatusBase.is_loading
                        };
                    }
                 
                    return bangDiem;
                })
            }
        case "IN_BANG_DIEM_LOAD_BANG_DIEM_SUCCESS":
            debugger
            const bangDiemResponse = action.payload.data as IBangDiemSinhVienResponse;   
            const bangDiemRequest = action.payload.request as IBangDiemSinhVienSelectRequest;
            return {
                ...state,
                bangDiemSinhViens: state.bangDiemSinhViens.map(bangDiem => {
                    if (bangDiem.id_sv === bangDiemRequest.id_sv && bangDiem.id_dt === bangDiemRequest.id_dt && bangDiem.hoc_ky === bangDiemRequest.hoc_ky && bangDiem.nam_hoc === bangDiemRequest.nam_hoc) {
                        debugger
                        return {
                            ...bangDiem,
                            status: eReducerStatusBase.is_completed,
                            bangDiemSinhVien: bangDiemResponse
                        };
                    }
                    return bangDiem;
                })
            }
        case "IN_BANG_DIEM_LOAD_BANG_DIEM_ERROR":
            const request = action.payload.request as IBangDiemSinhVienSelectRequest;
            return {
                ...state,
                bangDiemSinhViens: state.bangDiemSinhViens.map(bangDiem => {
                    if (bangDiem.id_sv === request.id_sv && bangDiem.id_dt === request.id_dt && bangDiem.hoc_ky === request.hoc_ky && bangDiem.nam_hoc === request.nam_hoc) {
                        return {
                            ...bangDiem,
                            status: eReducerStatusBase.is_completed
                        };
                    }
                    return bangDiem;
                })
            }
        case "IN_BANG_DIEM_CHANGE_SELECTED_IDS":
            return {
                ...state,
                sinhVienSelected: action.payload,
                bangDiemSinhViens: state.bangDiemSinhViens.map(bangDiem => {
                if (bangDiem.status === eReducerStatusBase.is_loading) {
                    return {
                        ...bangDiem,
                        status: eReducerStatusBase.is_not_initialization
                    };
                }
            return bangDiem;
             })
            };
        case "IN_BANG_DIEM_RESET_STATUS":
            return {
                ...state,
                bangDiemSinhViens: state.bangDiemSinhViens.map(bangDiem => {
                    if (bangDiem.id_sv === action.payload.id_sv && bangDiem.id_dt === action.payload.id_dt && bangDiem.hoc_ky === action.payload.hoc_ky && bangDiem.nam_hoc === action.payload.nam_hoc) {
                        return {
                            ...bangDiem,
                            status: eReducerStatusBase.is_not_initialization
                        };
                    }
                    return bangDiem;
                })
            }
        default:
            return state;
    }
}
    